import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Bubbles from "./components/site/Bubbles";
import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import Home from "./pages/Home";
import Leaderboard from "./pages/Leaderboard";
import Raffles from "./pages/Raffles";
import AuthCallback from "./pages/AuthCallback";
import AdminPage from "./pages/admin/AdminPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="page-bg">
          <Bubbles />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/raffles" element={<Raffles />} />
            <Route path="/auth/discord/callback" element={<AuthCallback />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <Footer />
        </div>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "rgba(8, 40, 78, 0.95)",
              border: "1px solid rgba(255,255,255,0.18)",
              color: "#e6f2ff",
              backdropFilter: "blur(10px)",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
